import { getOnboardingDocumentSigners } from 'commons/service/bank/onboardingDocuments'
import { OnboardingDocumentSignersListResponse } from 'commons/types/DTO/bank/applications/onboardingDocuments'
import { Keys, ReadHook, useStateManager } from 'state-manager'

export const useGetOnboardingDocumentSigners: ReadHook<OnboardingDocumentSignersListResponse, number> = (filter) =>
  useStateManager().use(Keys.BankDocumentOnboardingSigners.List(filter), () => getOnboardingDocumentSigners(filter), {
    keepPreviousData: true,
    refetchOnMount: false
  })
